import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { IPartner } from 'clickNgo/entities/partner/models'
import { I502Form } from 'clickNgo/models/crud/forms/i502Form'
import { CrudStore } from 'core/types/crudStore'

import { PartnerServiceOptions } from '../configs'
import { map502FromPartner } from '../mapping/map502FromPartner'
import { mapPartnerFrom502Crud } from '../mapping/mapPartnerFrom502Crud'

export const updateLegalPartnerRequest = (
  partner: Partial<IPartner>
): Promise<Partial<IPartner>> => {
  const source = CrudStore.get(CrudStoreItem.PartnerAllData, 'update-legal-partner')
  const formattedPartner = map502FromPartner(partner)

  return source
    .update(PartnerServiceOptions.LEGAL_PARTNER, [formattedPartner])
    .then(([result]: I502Form[]) => result && mapPartnerFrom502Crud(result))
}
